<template>
  <List :mapState="'academicStudents'" :allDispatch="'academicStudentAll'"></List>
</template>
<script>
import List from '@/components/modules/base/list.vue'
export default {
  name: 'Lists',
  components: {
    List
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/academic/students/list.vue